import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProcessInstance } from '@lib/workflow-util';
import { TranslateModule } from '@ngx-translate/core';
import {
    DEFAULT_IIM_BPMN_VIEWER_CONFIG,
    IimBpmnHighlight,
    IimBpmnViewerConfig,
    IimBpmnViewerModule,
    IimSpinnerModule,
} from '@iim-angular/components';
import { InvoiceDataService } from '../../../invoice-data.service';
import { MatButtonModule } from '@angular/material/button';

export interface IInvoiceProcessPreviewDialogData {
    processInstance: ProcessInstance;
    invoiceNumber: string;
}

@Component({
    selector: 'lib-invoice-process-preview-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, IimBpmnViewerModule, IimSpinnerModule, MatButtonModule],
    templateUrl: './invoice-process-preview-dialog.component.html',
    styleUrl: './invoice-process-preview-dialog.component.scss',
})
export class InvoiceProcessPreviewDialogComponent implements OnInit {
    public readonly data: IInvoiceProcessPreviewDialogData = inject(MAT_DIALOG_DATA);
    public readonly xml: WritableSignal<string> = signal<string>('');
    public highlights: WritableSignal<IimBpmnHighlight[]> = signal<IimBpmnHighlight[]>([]);
    public config: IimBpmnViewerConfig = {
        ...DEFAULT_IIM_BPMN_VIEWER_CONFIG,
        canvasDraggable: true,
    };

    private readonly _dialogRef: MatDialogRef<InvoiceProcessPreviewDialogComponent> = inject(MatDialogRef);
    private readonly _dataService = inject(InvoiceDataService);

    ngOnInit(): void {
        this._getData();
    }

    close() {
        this._dialogRef.close();
    }

    private _getData(): void {
        this.highlights.set(this.data.processInstance.getBpmnHighlights());
        this._dataService
            .getBpmnXmlForProcessDefinition(this.data.processInstance.definitionId)
            .subscribe((xml: string) => {
                this.xml.set(xml);
            });
    }
}
